<template>
  <RadioBasic
    v-slot="slotprops"
    v-model="value"
    :name="name"
    :options="options"
    :spacing="spacing"
    :has-error="!!errorMessage"
    @update:modelValue="updatedModelValue"
  >
    <div
      :id="`${slotprops.id}-error`"
      aria-live="polite"
      :class="['form-error', {'is-visible': errorMessage},errorMarginTop]"
    >
      <div
        class="error-red"
        role="graphics-symbol"
        :aria-label="errorMessage? 'Error' : ''"
        :aria-hidden="!errorMessage"
      />
      <span>{{ errorMessage }}</span>
    </div>
  </RadioBasic>
</template>

<script setup>
import { useField } from 'vee-validate';
import { computed, watch } from 'vue';
import RadioBasic from '../radioBasic';

const props = defineProps({
  name: {
    type: String,
    default: 'radio',
  },
  options: {
    type: Array,
    default: () => [],
  },
  required: {
    type: Boolean,
    default: false,
  },
  spacing: {
    type: String,
    default: 'margin-bottom-xxs',
  },
  modelValue: {
    type: String,
    default: '',
  },
});

const errorMarginTop = props.options.length > 1 ? 'radio-error-group' : 'radio-error';
const emit = defineEmits(['updatedModel', 'update:modelValue']);

const name = computed(() => props.name);
const { value, errorMessage } = useField(
  name,
  (ivalue) => {
    if (!props.required || ivalue.length > 0) {
      return true;
    }
    return 'Please choose one option.';
  }, {
    initialValue: props.modelValue,
  },
);
const updatedModelValue = (updatedValue) => {
  emit('updatedModel', updatedValue); // TODO TEC-2755 check usage and remove if unused
  emit('update:modelValue', updatedValue);
};

watch(() => props.modelValue, (newValue) => {
  value.value = newValue;
});
</script>

<style lang="scss" scoped>
@import "~@core/csg/src/scss/forms/forms.scss";
@import "~@csgIcons/_error-red.scss";
@include csg-forms;

.radio-container {
  +.radio-error-group.form-error.is-visible {
    margin-top: rem-calc(16);
  }
}
.radio-container {
  +.radio-error.form-error.is-visible {
    margin-top: rem-calc(8);
  }
}
</style>
